<template>
  <div class="item-box-content mainStep" style="min-height:632px">
    <div class="title-font-style">
      <span>退货管理</span>
    </div>
    <div v-if="state === 3||state === 4">
      <div class="text-box" style="margin-top:20px;">
        请根据提示分别完成退货出库、退票及退款结算，完成退货任务
        <br />退库出库、退款结算请通过右侧物流管理及退款结算模块完成
        <br />
        <br />采购合同退票请通过下侧快捷入口申请退票
      </div>
      <div style="margin-left: 30px;">
        <el-button type="primary" @click="onApplyForRefund" :disabled="!invoiceState">申请采购退票</el-button>
        <el-button type="primary" @click="onApplyForRedRefund" :disabled="!invoiceState">申请红字发票</el-button>
      </div>
    </div>
    <div style="margin-top:20px;" v-if="state === 1">
      <return-data :titleText="`请等待退货审批`"></return-data>
    </div>
    <div style="margin-top:20px;" v-if="state === 2">
      <div class="maintain-scheme">
        <span>{{'退货申请审批不通过，备注：'}}{{mark}}</span>
      </div>
    </div>
    <div v-if="contractFrom === '直备采购'&&(state === 1)">
      <el-steps align-center :active="state+1" style="margin:auto;padding:20px;margin-top:20px; ">
        <el-step title="发起申请" icon="el-icon-success"></el-step>
        <el-step title="退货审批" icon="el-icon-success"></el-step>
        <el-step title="退货出库、退票、退款结算" icon="el-icon-success"></el-step>
        <el-step title="退货完成" icon="el-icon-success"></el-step>
      </el-steps>
    </div>
    <div v-if="contractFrom === '直备采购'&&(state === 3||state === 4)">
      <el-steps align-center :active="state" style="margin:auto;padding:20px;margin-top:20px; ">
        <el-step title="发起申请" icon="el-icon-success"></el-step>
        <el-step title="退货审批" icon="el-icon-success"></el-step>
        <el-step title="退货出库、退票、退款结算" icon="el-icon-success"></el-step>
        <el-step title="退货完成" icon="el-icon-success"></el-step>
      </el-steps>
    </div>
    <div v-if="contractFrom === '采购计划'">
      <el-steps align-center :active="state-2" style="margin:auto;padding:20px;margin-top:20px; ">
        <el-step title="退货出库、退票、退款结算" icon="el-icon-success"></el-step>
        <el-step title="退货完成" icon="el-icon-success"></el-step>
      </el-steps>
    </div>
    <div v-if="contractFrom === '直备采购'&&state === 2">
      <el-steps align-center :active="3" style="margin:auto;padding:20px;margin-top:20px; ">
        <el-step title="发起申请" icon="el-icon-success"></el-step>
        <el-step title="退货审批" icon="el-icon-success"></el-step>
        <el-step title="审批不通过" icon="el-icon-success"></el-step>
      </el-steps>
    </div>
    <div class="title-text" v-if="state === 2" style="margin-left:20px;">
      <span class="text-title">{{"流程结束，所有产品返回正常状态，可通过售后管理页面再次发起申请"}}</span>
    </div>

    <div class="item-box-content">
      <el-row>
        <el-col :span="12">
          <div class="title-font-style">
            <span>退货清单</span>
          </div>
        </el-col>
      </el-row>
      <div class="title-text" v-if="state === 1">
        <span class="text-title">{{"待收货产品不再允许发起发货请求"}}</span>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="listContact"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column label="合同金额">
          <template slot-scope="scope">{{scope.row.contractMoney|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="已付账款">
          <template slot-scope="scope">{{scope.row.accountsPaid|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="已到期账款">
          <template slot-scope="scope">{{scope.row.accountsDue|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="当前负责人">
          <template slot-scope="scope">{{scope.row.currentPeron}}</template>
        </el-table-column>
        <el-table-column min-width="100" label="签订时间">
          <template slot-scope="scope">{{scope.row.signDate}}</template>
        </el-table-column>
        <el-table-column label="退货产品总价">
          <template slot-scope="scope">{{scope.row.productTotal|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="罚没金额">
          <template slot-scope="scope">{{scope.row.confiscatedTotal|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="罚没比例">
          <template slot-scope="scope">{{scope.row.confiscatedRatios|perCentFilter}}</template>
        </el-table-column>
      </el-table>
      <div v-for="(item,i) in list " :key="i">
        <div class="title">
          <span class="ht" style="padding:15px 0;">{{item.title}}</span>
        </div>
        <el-table
          border
          ref="tableRef"
          :data="item.arr"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          max-height="378"
        >
          <el-table-column fixed prop="brandName" label="品牌"></el-table-column>
          <el-table-column prop="proModel" label="型号"></el-table-column>
          <el-table-column prop="proOrderNum" label="订货号"></el-table-column>
          <el-table-column prop="proUnit" label="单位"></el-table-column>
          <el-table-column prop="retreatCount" label="数量"></el-table-column>
          <el-table-column prop="serialCode" label="产品序列号" width="100px">
            <template slot-scope="scope">
              <el-button type="text" @click="onSee(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="实付单价">
            <template slot-scope="scope">{{scope.row.actualPrice|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="发货状态">
            <template slot-scope="scope">{{scope.row.deliverState}}</template>
          </el-table-column>
          <el-table-column label="收票状态">
            <template slot-scope="scope">{{scope.row.invoiceState}}</template>
          </el-table-column>
          <el-table-column label="罚没单价">
            <template slot-scope="scope">{{scope.row.confiscateMoney|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="罚没比例">
            <template slot-scope="scope">{{scope.row.confiscatedRatio|perCentFilter}}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- --------------------待入库 查看序列号侧边栏---------------------- -->
    <see-shipment ref="seeShipmentRefs"></see-shipment>
  </div>
</template>
<script>
import logisticsSliderVue from './logisticsSlider.vue'
import returnData from '@/components/returnData'

export default {
  components: {
    'see-shipment': logisticsSliderVue,
    'return-data': returnData

  },
  props: ['contractFrom', 'state', 'listContact', 'mark', 'invoiceState'],
  data () {
    return {
      panelTitles: ['第一步信息', '第二步信息', '第三步信息'], // 根据需要传入，可N步,
      stepActive: 1,
      // stepChange自己根据需要写入，stepActive: 激活的第几部
      stepList: [
        { label: '发起申请', value: 0 },
        { label: '退货审批', value: 1 },
        { label: '退货出库、退票、退款结算', value: 3 },
        { label: '退货完成', value: 4 }
      ],
      stepListSell: [
        { label: '发起申请', value: 0 },
        { label: '退货审批', value: 1 },
        { label: '退货出库、退票、退款结算', value: 3 },
        { label: '退货完成', value: 4 }
      ],
      stepListPlan: [

        { label: '退货出库、退票、退款结算', value: 3 },
        { label: '退货完成', value: 4 }
      ],
      stepListPass: [
        { label: '发起申请', value: 0 },
        { label: '退货审批', value: 1 },
        { label: '审批不通过', value: 2 }
      ],
      list: [
        {
          title: '退货产品清单',
          arr: []
        }

      ]
    }
  },
  mounted () { },
  watch: {
    listContact (newVal) {
      this.list[0].arr = newVal[0].purchaseLaunchRetreatVoList
    }
  },
  methods: {
    onSee (row) {
      this.$refs.seeShipmentRefs.onInitialize(row)
    },
    // 申请退票
    onApplyForRefund () {
      this.$router.push({
        name: 'redApplyForRefund',
        query: {
          sendType: this.$route.query.type,
          pcbId: this.listContact[0].pcbId,
          typeex: 1
        }
      })
    },
    // 申请红字退票
    onApplyForRedRefund () {
      this.$router.push({
        name: 'redApplyForRefund',
        query: {
          type: 'red',
          sendType: this.$route.query.type,
          pcbId: this.listContact[0].pcbId,
          typeex: 2
        }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-step__icon {
  background: white !important;
}
.text-box {
  margin-bottom: 20px;
  font-weight: 500;
  line-height: 21px;
  margin-left: 30px;
  color: #83878a;
  font-size: 12px;
}
.title-text {
  margin: 20px 0 14px;
  .text-title {
    // margin-left: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #d35e5e;
    line-height: 12px;
  }
}
.maintain-scheme {
  height: 80px;
  background: rgba(243, 247, 255, 1);
  border-radius: 4px;
  text-align: left;
  padding-top: 50px;
  padding-left: 20px;

  .title-text {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
